import { Tag, type TableColumnsType } from 'antd';
import { CatalogueRowActions } from './CatalogueRowActions';
import type { Zone } from './reference-data.api';

interface BuildZoneColumnsArgs {
  onEdit: (row: Zone) => void;
  onDeactivate: (row: Zone) => Promise<void>;
  onReactivate: (row: Zone) => Promise<void>;
}

export function buildZoneColumns({ onEdit, onDeactivate, onReactivate }: BuildZoneColumnsArgs): TableColumnsType<Zone> {
  return [
    { title: 'Code', dataIndex: 'code', key: 'code', render: (code: string) => <span className="font-mono text-xs">{code}</span> },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Kind', dataIndex: 'kind', key: 'kind', render: (kind: string) => <Tag>{kind}</Tag> },
    { title: 'Country', dataIndex: 'country', key: 'country' },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => <Tag color={isActive ? 'success' : 'default'}>{isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: '',
      key: 'actions',
      render: (_, row) => <CatalogueRowActions row={row} onEdit={onEdit} onDeactivate={onDeactivate} onReactivate={onReactivate} />,
    },
  ];
}
